import moment from "moment";
import { getStaffScanMapPositions } from "./staff-scan-location-helper";


const EMPTY_VALUE = "—";
const HISTORY_FIELDS = [
    { name: "latitude", labelKey: "STAFF_MANAGEMENT.History_Latitude", numeric: true },
    { name: "longitude", labelKey: "STAFF_MANAGEMENT.History_Longitude", numeric: true },
    { name: "radius", labelKey: "STAFF_MANAGEMENT.History_Radius", numeric: true },
    { name: "country", labelKey: "STAFF_MANAGEMENT.History_Country" },
    { name: "address", labelKey: "STAFF_MANAGEMENT.History_Address" },
];

const isEmpty = (value) => (
    value === null || value === undefined ||
    (typeof value === "string" && value.trim() === "")
);

const toNumber = (value) => {
    if (isEmpty(value) || ![ "number", "string" ].includes(typeof value))
    {
        return undefined;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : undefined;
};

export const getStaffCheckInHistoryActor = (log) => (
    `${ log?.relUser?.name || "" } ${ log?.relUser?.surname || "" }`.trim() ||
    (isEmpty(log?.user_id) ? EMPTY_VALUE : String(log.user_id))
);

export const formatStaffCheckInHistoryDateTime = (value) => {
    if (!value)
    {
        return EMPTY_VALUE;
    }

    const date = moment(value, [ "YYYY-MM-DD HH:mm:ss", moment.ISO_8601 ], true);

    return date.isValid() ? date.format("DD.MM.YYYY, HH:mm:ss") : EMPTY_VALUE;
};

export const formatStaffCheckInHistoryCoordinate = (value) => {
    const number = toNumber(value);

    return number === undefined ? EMPTY_VALUE : number.toFixed(6);
};

export const formatStaffCheckInHistoryRadius = (value) => {
    const number = toNumber(value);

    return number === undefined ? EMPTY_VALUE : `${ number } m`;
};

export const getStaffCheckInHistoryChangedFields = (log) => (
    (Array.isArray(log?.changedFields) ? log.changedFields : []).map((value) => {
        const name = String(value);
        const normalizedName = name.toLowerCase().replace(/^check_/, "");
        const field = HISTORY_FIELDS.find((item) => item.name === normalizedName);

        return { name, labelKey: field?.labelKey };
    })
);

const comparisonValue = (value, numeric) => {
    if (isEmpty(value))
    {
        return null;
    }

    return numeric ? (toNumber(value) ?? value) : value;
};

const formatFieldValue = (name, value) => {
    if (name === "latitude" || name === "longitude")
    {
        return formatStaffCheckInHistoryCoordinate(value);
    }

    if (name === "radius")
    {
        return formatStaffCheckInHistoryRadius(value);
    }

    return isEmpty(value) ? EMPTY_VALUE : String(value);
};

export const getStaffCheckInHistoryComparison = (log) => (
    HISTORY_FIELDS.map(({ name, labelKey, numeric }) => {
        const oldValue = log?.[ `old_${ name }` ];
        const newValue = log?.[ `new_${ name }` ];

        return {
            name,
            labelKey,
            oldValue: formatFieldValue(name, oldValue),
            newValue: formatFieldValue(name, newValue),
            changed: comparisonValue(oldValue, numeric) !== comparisonValue(newValue, numeric),
        };
    })
);

export const getStaffCheckInHistoryMapSnapshot = (log) => {
    const scan = {
        latitude: toNumber(log?.new_latitude),
        longitude: toNumber(log?.new_longitude),
    };
    const zone = { ...scan, radius: toNumber(log?.new_radius) };
    const positions = getStaffScanMapPositions({ scan, zone });

    if (!positions)
    {
        return undefined;
    }

    // Historical snapshots are not subject to today's setup radius limits.
    return { scan, zone: positions.zone ? zone : undefined };
};
